import { ElementController, selectSingle, setData } from 'js-common';

import { DONATION_CONTROLLER_ID } from './constants';

/**
 * Controller for donation block.
 */
export default class Donation extends ElementController {
  static id = DONATION_CONTROLLER_ID;

  /**
   * DOM loaded, initialize elements and bind events.
   */
  init() {
    // IMPORTANT! Never cache the checkout form or any of its elements in a
    // variable. The form is replaced after each request so the variable will
    // point to a node no longer in the DOM.
    this.handleAmountChange();
    this.on(this.root, 'change', 'input', this.handleAmountChange);
  }

  handleAmountChange = () => {
    const radioButtons = this.selectAll('input[type="radio"');
    const checked = radioButtons.find((el) => el.checked);
    if (!checked) {
      return;
    }

    // Set active radio button value for CSS.
    setData(this.root, 'current-amount', checked.value);

    // Set hidden input as not required.
    const customAmountRadioButton = this.selectSingle(
      'input[value="custom_amount"]',
    );
    const customAmountInput = selectSingle(
      this.selectSingle('.form-field--custom_amount'),
      'input',
    );
    customAmountInput.required = checked === customAmountRadioButton;
    customAmountInput.ariaInvalid = checked === customAmountRadioButton;
  };
}
